import type { ButtonHTMLAttributes } from "react";

import { Button } from "@jti/core-components/components/Button";
import type { IBundleOptionInput } from "@jti/magento";
import { useAddProduct } from "@jti/ui/hooks/useAddProduct";

type QuickAddToCartCtaButtonProps = {
  label: string;
  sku: string;
  bundle?: IBundleOptionInput[];
  color?: "primary" | "secondary";
  theme?: "dark" | "light";
} & ButtonHTMLAttributes<HTMLButtonElement>;

export const QuickAddToCartCtaButton = ({
  label,
  sku,
  theme,
  bundle = [],
  color = "primary",
  ...restProps
}: QuickAddToCartCtaButtonProps) => {
  const { isRunning, addProductToCart } = useAddProduct(sku, bundle, false);

  return (
    <Button
      {...restProps}
      onClick={() => addProductToCart(1)}
      variant={color}
      className={theme ? `${theme}-theme` : restProps.className}
      pending={isRunning}
    >
      {label}
    </Button>
  );
};
